import React from 'react'
import { Query } from '@apollo/client/react/components'
import styled from 'styled-components'
import {SIGN_OUT_MUTATION} from '../../mutations/SIGN_OUT_MUTATION'
import {ME_QUERY} from '../../queries/ME_QUERY'
import {
  MeQuery,
  SignOutMutation,
} from '../../schema/schemaTypes'
import {media} from '../../utils/media'
import avatar from './avatar.svg'
import downArrow from './down-arrow.svg'
import Swal from 'sweetalert2'
import {apolloClient} from '../../utils/apolloClient'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

interface IInputProps {
  color: string | null
}

interface IChildState {
  menuClicked: boolean
}

export class ProfileDropdown extends React.Component<IInputProps, IChildState> {
  public state: IChildState = {menuClicked: false}

  public render() {
    return (
      <Query<MeQuery> query={ME_QUERY}>{({data, loading, error}) => {
        if (loading) {
          return null
        }
        if (error || !data || !data.me) {
          location.reload()
          return null
        }
        const me = data!.me!
        return (
          <Button id="menu"
                  onClick={this.onClickProfile}
                  onBlur={this.UnselectProfile}>
            {!this.state.menuClicked &&
            <BeforeClick style={{display:'flex'}}>
              <Username style={this.props.color ? {color: this.props.color} : {}}>
                {me.username}
              </Username>
              <DropdownArrow src={downArrow} />
            </BeforeClick>}
            {this.state.menuClicked &&
            <AfterClick>
              <Username style={this.props.color ? {color: this.props.color} : {}}>
                {me.username}
              </Username>
              <DropdownArrow src={downArrow} style={{opacity: 0}}/>
              <MenuDropdown style={this.props.color ? {color: this.props.color} : {}}>
                <li style={{marginTop: 10}} onMouseDown={this.onClickExit}>{lang === 'es' ? 'Salida' : 'Exit'}</li>
              </MenuDropdown>
            </AfterClick>
            }
          </Button>
        )
      }}</Query>
    )
  }

  private onClickProfile = () => {
    this.setState({menuClicked: true})
    document.getElementById('menu')!.focus()
  }

  private UnselectProfile = () => {
    this.setState({menuClicked: false})
  }

  private onClickExit = async () => {
    const response = await Swal.fire({
      title: `<strong>${lang === 'es' ? 'cerrar sesión' : 'LOG OUT'}</strong>`,
      html:
        lang === 'es' ? `Esto lo llevará de vuelta a la página de inicio de sesión.` : `This will take you back to the login page. Are you sure you want to leave?`,
      showCancelButton: true,
      showCloseButton: true,
      focusConfirm: false,
      confirmButtonText:
        'No',
      cancelButtonText:
        lang === 'es' ? 'Si' : 'Yes',
    })

    if (response.dismiss === Swal.DismissReason.cancel)  {
      await apolloClient.mutate({
        mutation: SIGN_OUT_MUTATION,
      })
      // @ts-ignore
      if(window.ReactNativeWebView) {
        // @ts-ignore
        window.ReactNativeWebView.postMessage(JSON.stringify({name: 'logout'}), '*')
      }
      localStorage.clear()
      location.assign('/')
    }
  }
}

const Button = styled.button`
  border: none;
  appearance: none;
  background: transparent;
  margin-left: auto;
  display:flex;
  align-items:center;

  font-family: Nunito;
  font-weight: 900;
  font-size: 22px;
  color: #AEBFCC;
  letter-spacing: 0.49px;
`

const BeforeClick = styled.div`
  margin: 15px 0px 15px 10px;
  margin-top: calc(15px + env(safe-area-inset-top));
`

const AfterClick = styled.div`
  background-color: #34424C;
  border-radius: 10px;
  margin: 5px 0px 15px 0px;
  padding: 10px 0px 10px 10px;
  position: relative;
  margin-top: calc(90px + env(safe-area-inset-top));
  
  ${media.desktop`
    padding: 10px 0px 10px 31px
  `}
`

const Username = styled.span`
  display: none;
  max-width:12vw;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;

  ${media.desktop`
    display: inline-block;
  `}
`

const MenuDropdown = styled.ul`
  text-align: center;
  list-style: none;
  margin-top: 10px;
  margin-right: 15px;
  
  ${media.desktop`
    margin-right: 31px;
  `}
`

const AvatarImg = styled.img`
  ${media.tablet`
    margin: 0 14px 0 0;
  `}
`

const DropdownArrow = styled.img`
  margin: 0 55px 0 47px;
  display:inline-block;
  ${media.tablet`
    padding-right: 0px;
  `}
  ${media.desktop`
    margin: 0 10px 0 8px;
  `}
`



// WEBPACK FOOTER //
// ./src/organisms/ProfileDropdown/index.tsx